import { Box, Typography } from "@mui/material";
import React from "react";

const NoMatch = () => {
  return (
    <Box
      height="70vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Typography>404 : Page Not Found</Typography>
    </Box>
  );
};

export default NoMatch;
